import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Modal, Button } from 'antd';

import { errorConfigSelector } from '@store/errorLogicConfig/configContainer/selectors';
import { warningModalSelector } from '@store/errorLogicConfig/base/selectors';
import { setWarningContainerVisibility } from '@store/errorLogicConfig/base/actions';
import { updateConfig } from '@store/errorLogicConfig/configContainer/actions';
import { displayMessage } from './utils';
import { StyledPara } from '../styled';

function WarningModal() {
  const dispatch = useDispatch();

  const visible = useSelector(warningModalSelector);
  const data = useSelector(errorConfigSelector);
  const { state } = data;
  const displayText = displayMessage(state);
  let text = '';
  let action = '';

  switch (state) {
  case 0: text = 'Delete Config'; action = 'Delete'; break;
  case 1: text = 'Disable Config'; action = 'Disable'; break;
  case 2: text = 'Enable Config'; action = 'Enable'; break;
  }

  const onConfirm = (e) => {
    dispatch(updateConfig(data, action));
    dispatch(setWarningContainerVisibility(false));
  };

  const onCancel = (e) => {
    dispatch(setWarningContainerVisibility(false));
  };

  const footerButtons = [
    <Button key="discard" onClick={onCancel}>Discard</Button>,
    <Button key="save" type='primary' onClick={onConfirm}>Confirm</Button>,
  ];

  return (
    <>
      <Modal
        title={text}
        width="550px"
        open={visible}
        onCancel={onCancel}
        footer={footerButtons}
      >
        <StyledPara>
          <p>
            {`Are you sure you want to ${action.toLowerCase()} the config?`}
          </p>
          {displayText}
        </StyledPara>
      </Modal>
    </>
  );
}

export default WarningModal;
